import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Drawer,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
} from '@material-ui/core'
import { ChevronLeft } from '@material-ui/icons'
import ThemeEditor from './ThemeEditor'

const DrawerBase = styled(Drawer)`
  .MuiDrawer-paper {
    width: 300px;
  }
`
const Title = styled(Typography)`
  margin-left: ${props => props.theme.spacing(4)}px;
`

const ThemeEditorDrawer = props => {
  const { open, handleClose, theme, setTheme, logo, setLogo } = props

  return (
    <DrawerBase anchor="left" open={open} onClose={handleClose}>
      <AppBar position="relative">
        <Toolbar>
          <Title variant="h6">Edit Theme</Title>
          <IconButton
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            style={{ marginLeft: `auto` }}
          >
            <ChevronLeft />
          </IconButton>
        </Toolbar>
      </AppBar>
      <ThemeEditor
        theme={theme}
        setTheme={setTheme}
        logo={logo}
        setLogo={setLogo}
      />
    </DrawerBase>
  )
}

ThemeEditorDrawer.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  theme: PropTypes.object,
  setTheme: PropTypes.func,
  logo: PropTypes.object,
  setLogo: PropTypes.func,
}

export default ThemeEditorDrawer
